<template>
  <v-container>
    <component :is="getUsatoClientiComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/usato/clienti/Index'
  import Insert from './../components/usato/clienti/Insert'

  export default {
    name: 'UsatoClienti',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getUsatoClientiComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_USATO_CLIENTI_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_USATO_CLIENTI_COMPONENT('Index')
    }
  }
</script>

<style>
</style>